var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccounting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    width: 406,
    height: 306,
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3605.5334,
    y1: 4066.749,
    x2: 1124.1327,
    y2: 985.0048
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2922.885,2851.42c-56.997,60.004-110.927,98.699-153.536,129.272 c-500.859,359.372-1093.509,254.617-1219.464,229.034c-185.996-37.777-545.521-110.798-805.452-416.471 c-393.253-462.458-332.018-1191.047-26.984-1671.998c55.795-87.974,350.523-576.252,949.556-654.556 c362.528-47.389,785.12,48.189,1091.149,304.58C3400.537,1309.47,3354.806,2396.708,2922.885,2851.42z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2935.597,621.209c6.104-13.276-8.652-26.522-21.309-19.221 c-128.531,74.136-451.106,310.786-509.661,843.064c-73.465,667.822-264.377,872.941-466.678,977.884 c0,0,247.158-13.625,449.102-219.829C2882.871,1696.831,2827.068,857.263,2935.597,621.209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2807.813,805.16c-30.157,69.18-58.935,138.918-85.12,209.609 c-26.552,70.54-50.955,141.854-73.099,213.825c-21.866,72.05-42.378,144.5-59.781,217.713 c-17.731,73.131-32.302,146.942-46.672,221.101c-14.776,74.036-29.24,148.703-51.392,222.117 c-22.039,73.28-53.179,145.107-96.52,209.115c-10.822,15.948-21.977,31.76-33.952,46.757 c-11.702,15.226-24.082,29.938-36.72,44.422c-25.426,28.849-52.81,56.06-82.088,81.115 c-58.693,49.969-124.951,90.96-194.726,122.432c-7.344,3.313-15.982,0.044-19.295-7.3c-3.253-7.211-0.16-15.671,6.907-19.111 l0.05-0.024c16.754-8.135,33.395-16.452,49.608-25.482c8.18-4.387,16.148-9.126,24.203-13.715 c7.87-4.887,15.934-9.471,23.645-14.596c31.182-19.975,60.924-42.115,88.881-66.344 c56.092-48.132,105.28-104.895,146.792-165.969c20.417-30.781,38.531-63.013,54.102-96.527 c15.547-33.529,28.541-68.305,39.561-103.849c22.056-71.126,36.983-144.913,52.29-218.837 c15.406-73.922,31.396-148.099,50.413-221.503c9.408-36.723,19.475-73.273,30.192-109.624 c5.253-18.205,10.858-36.306,16.43-54.414c5.745-18.054,11.59-36.075,17.58-54.043c24.094-71.834,50.368-142.898,78.85-213.033 c28.818-69.998,59.484-139.208,92.765-207.119c0.952-1.942,3.295-2.744,5.236-1.792 C2807.833,801.006,2808.64,803.254,2807.813,805.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2496.715,2649.853c4.67,26.516,34.902,39.645,57.655,25.251 c125.549-79.415,460.214-336.049,520.802-845.298c51.163-430.037,119.773-658.359,158.101-759.851 c8.105-21.461-15.899-40.795-35.165-28.342C2985.545,1179.008,2327.494,1689.053,2496.715,2649.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2532.588,2656.344c0.484,0.459,1.018,0.877,1.604,1.248c4.899,3.114,11.396,1.667,14.509-3.232 c3.53-5.555,354.103-562.241,452.253-1156.966c0.943-5.723-2.932-11.133-8.661-12.085c-5.729-0.943-11.137,2.932-12.085,8.661 c-97.434,590.396-445.744,1143.595-449.25,1149.113C2528.215,2647.398,2529.01,2652.952,2532.588,2656.344z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027604115447622925330000015497740549139079567_",
    gradientUnits: "userSpaceOnUse",
    x1: 684.9249,
    y1: 3363.356,
    x2: 3505.6497,
    y2: -549.2584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027604115447622925330000015497740549139079567_)"
    },
    d: "M936.494,769.932l1450.798,38.44 c80.04,2.121,144.376,66.594,146.328,146.637l51.36,2106.226c1.527,62.637-49.112,114.095-111.765,113.573l-1663.599-13.834 c-58.871-0.49-105.892-49.176-104.332-108.028l56.088-2116.932C763.868,841.794,842.273,767.438,936.494,769.932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1053.693,3131.052c-0.046,0-0.092-0.001-0.135-0.003l-185.995-7.337 c-61.863-2.438-110.858-54.773-109.22-116.663l7.444-280.912c0.049-1.863,1.721-3.407,3.458-3.279 c1.859,0.05,3.33,1.598,3.281,3.457l-7.444,280.912c-1.543,58.223,44.547,107.457,102.743,109.752l185.995,7.337 c1.859,0.073,3.311,1.64,3.235,3.5C1056.984,3129.629,1055.494,3131.052,1053.693,3131.052z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133503017947994766750000002392297590748711320_",
    gradientUnits: "userSpaceOnUse",
    x1: 838.1406,
    y1: 1920.2527,
    x2: 2486.8477,
    y2: 1920.2527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133503017947994766750000002392297590748711320_)"
    },
    d: "M941.406,753.001 c197.409,32.116,876.488,133.262,1440.91,104.947c25.74-1.292,47.517,18.762,48.202,44.525l56.31,2115.738 c0.772,29.01-22.006,53.197-51.01,54.143c-237.274,7.743-1214.351,36.089-1561.384-9.581 c-21.12-2.779-36.724-21.037-36.285-42.336l45.743-2219.499C884.513,770.788,911.643,748.159,941.406,753.001z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M996.309,863.577c184.085,29.948,817.33,124.268,1343.656,97.864 c24.003-1.205,44.309,17.495,44.949,41.519l52.51,1972.936c0.72,27.051-20.521,49.606-47.568,50.488 c-221.259,7.221-1132.388,33.653-1455.998-8.934c-19.695-2.592-34.245-19.617-33.836-39.479l42.656-2069.694 C943.255,880.163,968.554,859.062,996.309,863.577z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067952258063176161660000003084325726844910498_",
    gradientUnits: "userSpaceOnUse",
    x1: 1326.1075,
    y1: 3220.991,
    x2: 658.5877,
    y2: 4099.0977,
    gradientTransform: "matrix(0.9997 0.0265 -0.0265 0.9997 686.7247 -2962.6826)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067952258063176161660000003084325726844910498_)"
    },
    d: "M1759.471,504.75 c-51.438-37.844-97.024-38.329-129.353-29.715c-29.49,7.859-49.202,35.607-47.223,66.063l9.832,151.357l164.223,18.969 C1756.949,711.424,1860.351,578.972,1759.471,504.75z M1683.854,624.645c-22.669-0.601-40.558-19.464-39.958-42.132 c0.601-22.669,19.465-40.559,42.133-39.959c22.668,0.602,40.559,19.465,39.958,42.133 C1725.385,607.357,1706.523,625.246,1683.854,624.645z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1607.956,632.986c-2.835-1.125-4.926-3.805-5.135-7.057l-1.564-24.107 c-0.292-4.494,3.113-8.37,7.607-8.663c4.49-0.3,8.38,3.102,8.67,7.612l1.564,24.106c0.292,4.494-3.114,8.371-7.608,8.661 C1610.246,633.62,1609.045,633.418,1607.956,632.986z M1604.89,585.749c-2.835-1.125-4.926-3.803-5.135-7.057l-1.19-18.302 c-2.013-31.001,18.214-59.275,48.095-67.242c20.454-5.451,41.402-5.761,62.254-0.91c4.314,1.077,7.12,5.402,6.093,9.794 c-1.019,4.385-5.403,7.119-9.791,6.098c-18.216-4.243-36.506-3.974-54.353,0.781c-22.382,5.963-37.53,27.166-36.02,50.428 l1.19,18.304c0.29,4.494-3.115,8.369-7.608,8.661C1607.179,586.383,1605.979,586.181,1604.89,585.749z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124136429320964943200000005035673599307259044_",
    gradientUnits: "userSpaceOnUse",
    x1: 1399.3329,
    y1: 3276.6475,
    x2: 731.8085,
    y2: 4154.7603,
    gradientTransform: "matrix(0.9997 0.0265 -0.0265 0.9997 686.7247 -2962.6826)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124136429320964943200000005035673599307259044_)"
    },
    d: "M1365.477,784.079l2.012-75.914 c0.692-26.205,22.969-46.618,49.135-45.026l522.914,31.799c23.207,1.411,41.532,20.245,42.308,43.481l2.441,73.058 L1365.477,784.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1540.712,691.076l22.509,0.596L1540.712,691.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1391.536,764.603c-3.09-1.226-5.238-4.28-5.143-7.799l0.813-30.711 c0.332-12.609,5.555-24.332,14.71-33.014c9.154-8.681,21.141-13.283,33.753-12.95l82.751,2.196 c4.48,0.133,8.056,3.864,7.934,8.374c-0.119,4.503-3.866,8.055-8.371,7.939l-82.75-2.198 c-17.039-0.451-31.273,13.045-31.722,30.088l-0.815,30.711c-0.12,4.503-3.867,8.055-8.371,7.939 C1393.343,765.148,1392.403,764.947,1391.536,764.603z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039130888138807289170000004642052920821156767_",
    gradientUnits: "userSpaceOnUse",
    x1: 2423.3093,
    y1: -1958.9714,
    x2: 2039.1252,
    y2: -543.5533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039130888138807289170000004642052920821156767_)"
    },
    d: "M1202.217,751.95l915.243,24.226 c32.909,0.87,60.417,25.298,65.173,57.875l0.656,4.495c5.207,35.681-22.999,67.444-59.046,66.489l-938.986-24.879 c-21.573-0.57-38.286-19.063-36.681-40.584l3.134-41.974C1153.669,771.344,1175.898,751.255,1202.217,751.95z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2334.13,2773.807c-0.152,15.618-10.809,28.316-23.816,28.366l-1279.027,4.875 c-14.303,0.055-25.89-13.192-25.867-29.591l0.004-2.48c0.023-16.403,11.652-29.72,25.96-29.744l1279.496-2.037 c13.01-0.021,23.425,12.628,23.273,28.249L2334.13,2773.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2334.13,2906.694c-0.152,15.618-10.809,28.316-23.816,28.366l-1279.027,4.875 c-14.303,0.055-25.89-13.192-25.867-29.591l0.004-2.48c0.023-16.403,11.652-29.72,25.96-29.744l1279.496-2.037 c13.01-0.021,23.425,12.628,23.273,28.249L2334.13,2906.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2339.029,1951.014c-0.152,15.618-10.809,28.316-23.815,28.366l-1279.027,4.875 c-14.303,0.055-25.89-13.192-25.867-29.591l0.004-2.48c0.023-16.402,11.652-29.721,25.96-29.744l1279.496-2.036 c13.01-0.021,23.425,12.628,23.273,28.249L2339.029,1951.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1986.729,1063.533c-0.466,15.612-5.792,28.259-11.901,28.254 c-182.132,4.742-382.945-1.647-594.529-14.454c-6.719-0.006-18.127,0.571-17.702-15.822l0.064-2.479 c0.425-16.397,11.307-41.297,18.027-41.259c222.365,21.837,422.604,27.998,595.894,15.063 c6.111,0.035,10.683,12.723,10.217,28.338L1986.729,1063.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2311.748,2281.545c-0.152,15.618-5.223,28.37-11.332,28.487l-600.72,11.481 c-6.718,0.129-12.091-13.058-11.996-29.456l0.014-2.48c0.096-16.402,5.626-29.779,12.346-29.876l600.926-8.645 c6.111-0.088,10.936,12.507,10.784,28.127L2311.748,2281.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2312.777,2412.997c-0.152,15.618-5.223,28.37-11.332,28.487l-600.72,11.481 c-6.718,0.129-12.091-13.058-11.996-29.456l0.015-2.48c0.096-16.402,5.626-29.779,12.346-29.876l600.926-8.645 c6.11-0.088,10.936,12.507,10.784,28.127L2312.777,2412.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2312.091,2535.622c-0.152,15.618-5.223,28.371-11.332,28.487l-600.72,11.481 c-6.717,0.129-12.091-13.058-11.995-29.456l0.015-2.48c0.096-16.402,5.626-29.779,12.346-29.876l600.926-8.645 c6.11-0.088,10.936,12.507,10.784,28.128L2312.091,2535.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1548.228,2629.094h-471.322c-31.638,0-57.285-25.647-57.285-57.285v-390.067 c0-31.637,25.647-57.285,57.285-57.285h471.322c31.638,0,57.285,25.647,57.285,57.285v390.067 C1605.513,2603.447,1579.866,2629.094,1548.228,2629.094z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.57,
      fill: "#FFFFFF"
    },
    d: "M1130.898,1747.48c-2.226-0.002-4.456-0.789-6.181-2.367 c-3.517-3.217-3.599-8.503-0.184-11.804l290.156-280.459c2.961-2.862,7.704-3.188,11.164-0.771l147.868,103.4l267.225-237.457 c2.857-2.54,7.207-2.705,10.387-0.396l143.846,104.405l212.206-222.425c2.945-3.09,7.931-3.127,11.132-0.08 c3.198,3.044,3.404,8.017,0.459,11.107l-216.76,227.489c-2.761,2.896-7.322,3.269-10.637,0.867l-144.327-104.604 l-267.032,237.618c-2.941,2.616-7.413,2.849-10.688,0.561l-147.648-103.091l-284.626,275.485 C1135.521,1746.638,1133.212,1747.482,1130.898,1747.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1417.754,1428.878c-19.014,0.699-33.603,15.273-32.552,32.549 c1.053,17.275,17.343,30.659,36.351,29.897c18.969-0.761,33.471-15.329,32.424-32.542 C1452.931,1441.571,1436.728,1428.181,1417.754,1428.878z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1126.776,1709.966c-19.622,1.001-34.686,16.041-33.611,33.59 c1.077,17.547,17.88,30.905,37.496,29.838c19.575-1.065,34.548-16.098,33.477-33.58 C1163.069,1722.331,1146.356,1708.966,1126.776,1709.966z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1571.359,1536.448c-18.706,0.802-33.055,15.345-32.016,32.48 c1.041,17.134,17.071,30.321,35.772,29.456c18.663-0.863,32.926-15.4,31.891-32.472 C1605.972,1548.84,1590.028,1535.648,1571.359,1536.448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1993.245,1398.638c-17.859,0.648-31.545,14.747-30.538,31.49 c1.006,16.742,16.32,29.739,34.173,29.032c17.818-0.706,31.425-14.801,30.424-31.483 C2026.302,1410.993,2011.068,1397.991,1993.245,1398.638z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2243.433,1205.734c-0.985-16.481-15.855-29.501-33.247-29.078 c-17.425,0.423-30.773,14.175-29.784,30.715c0.989,16.538,15.938,29.554,33.356,29.073 C2231.145,1235.963,2244.416,1222.215,2243.433,1205.734z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1843.51,1294.939c-18.151,0.55-32.068,14.681-31.049,31.562 c1.019,16.879,16.58,30.067,34.727,29.457c18.109-0.61,31.944-14.736,30.931-31.555 C1877.106,1307.582,1861.625,1294.39,1843.51,1294.939z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.74,
      fill: "#FFFFFF"
    },
    d: "M2334.575,1830.372H1057.642c-12.62,0-24.417-4.984-33.214-14.035 c-8.796-9.049-13.446-20.982-13.087-33.597l15.759-555.797c0.161-5.583,4.87-9.895,10.392-9.82 c5.581,0.16,9.978,4.811,9.82,10.392l-15.759,555.797c-0.204,7.11,2.415,13.833,7.371,18.932 c4.959,5.101,11.606,7.909,18.718,7.909h1276.933c5.584,0,10.109,4.526,10.109,10.109S2340.16,1830.372,2334.575,1830.372z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042738256092176975000000009074612487528202416_",
    gradientUnits: "userSpaceOnUse",
    x1: 3871.7935,
    y1: 370.0044,
    x2: 1910.4255,
    y2: 3443.4885
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042738256092176975000000009074612487528202416_)"
    },
    d: "M1909.268,1899.835 c-6.315,225.505-26.793,1003.359-17.018,1279.006c1.036,29.202,27.478,52.641,60.462,53.597 c163.135,4.726,761.18,16.706,1028.014,6.795c55.578-2.065,99.775-41.92,100.928-91.158 c5.546-236.697,17.779-902.435-11.298-1207.41c-3.485-36.54-35.879-65.639-77.094-69.29 c-177.662-15.735-778.279-54.198-1008.808-40.953C1942.879,1832.809,1910.299,1862.96,1909.268,1899.835z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040554875810214531050000010621648004149657253_",
    gradientUnits: "userSpaceOnUse",
    x1: 1364.8406,
    y1: 2808.0532,
    x2: 3144.0452,
    y2: 1669.0928
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040554875810214531050000010621648004149657253_)"
    },
    d: "M1956.122,1999.26v191.107 c0,36.648,29.709,66.357,66.357,66.357h913.069c36.648,0,66.356-29.709,66.356-66.357V1999.26 c0-36.648-29.709-66.357-66.356-66.357h-913.069C1985.831,1932.903,1956.122,1962.613,1956.122,1999.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M2955.333,1998.164c-8.073-8.346-19.133-13.141-30.743-13.324l-854.373-13.575 c-22.841-0.364-42.113,16.912-44.243,39.655l-17.753,189.546c-1.454,15.521,24.079,28.587,56.631,28.983l839.967,10.178 c32.502,0.394,59.371-12.002,59.64-27.514l3.168-182.78C2967.828,2017.723,2963.406,2006.508,2955.333,1998.164z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123418124081411912240000013836210336575946431_",
    gradientUnits: "userSpaceOnUse",
    x1: 1783.5145,
    y1: 2741.873,
    x2: 2587.7231,
    y2: 1967.636
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123418124081411912240000013836210336575946431_)"
    },
    d: "M2184.389,2450.486 c0,33.716-27.332,61.048-61.048,61.048h-74.32c-33.716,0-61.048-27.332-61.048-61.048l0,0c0-33.716,27.332-61.048,61.048-61.048 h74.32C2157.057,2389.438,2184.389,2416.77,2184.389,2450.486L2184.389,2450.486z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145750104101846150930000008166400766374880647_",
    gradientUnits: "userSpaceOnUse",
    x1: 1916.2969,
    y1: 2879.7954,
    x2: 2720.5054,
    y2: 2105.5583
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145750104101846150930000008166400766374880647_)"
    },
    d: "M2460.433,2450.486 c0,33.716-27.332,61.048-61.048,61.048h-74.32c-33.716,0-61.048-27.332-61.048-61.048l0,0c0-33.716,27.333-61.048,61.048-61.048 h74.32C2433.101,2389.438,2460.433,2416.77,2460.433,2450.486L2460.433,2450.486z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145741039694251121720000009581504287102333859_",
    gradientUnits: "userSpaceOnUse",
    x1: 2043.9714,
    y1: 3012.4141,
    x2: 2848.1802,
    y2: 2238.177
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145741039694251121720000009581504287102333859_)"
    },
    d: "M2725.86,2450.486 c0,33.716-27.332,61.048-61.048,61.048h-74.319c-33.716,0-61.048-27.332-61.048-61.048l0,0 c0-33.716,27.332-61.048,61.048-61.048h74.319C2698.528,2389.438,2725.86,2416.77,2725.86,2450.486L2725.86,2450.486z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051382141855132068140000017856186185629658046_",
    gradientUnits: "userSpaceOnUse",
    x1: 3142.9453,
    y1: 2070.1494,
    x2: 2857.6423,
    y2: 2521.6912
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051382141855132068140000017856186185629658046_)"
    },
    d: "M2994.923,2459.448 c0,34.262-27.775,62.037-62.037,62.037h-71.832c-34.262,0-62.037-27.775-62.037-62.037l0,0 c0-34.262,27.775-62.037,62.037-62.037h71.832C2967.148,2397.411,2994.923,2425.186,2994.923,2459.448L2994.923,2459.448z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167397377202234971890000009987775705597812663_",
    gradientUnits: "userSpaceOnUse",
    x1: 1878.9988,
    y1: 2841.0547,
    x2: 2683.2068,
    y2: 2066.8184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167397377202234971890000009987775705597812663_)"
    },
    d: "M2184.389,2641.594 c0,33.716-27.332,61.048-61.048,61.048h-74.32c-33.716,0-61.048-27.332-61.048-61.048l0,0c0-33.716,27.332-61.048,61.048-61.048 h74.32C2157.057,2580.545,2184.389,2607.877,2184.389,2641.594L2184.389,2641.594z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116226782112594531300000018183182318110514351_",
    gradientUnits: "userSpaceOnUse",
    x1: 2011.7811,
    y1: 2978.9771,
    x2: 2815.9893,
    y2: 2204.7405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116226782112594531300000018183182318110514351_)"
    },
    d: "M2460.433,2641.594 c0,33.716-27.332,61.048-61.048,61.048h-74.32c-33.716,0-61.048-27.332-61.048-61.048l0,0c0-33.716,27.333-61.048,61.048-61.048 h74.32C2433.101,2580.545,2460.433,2607.877,2460.433,2641.594L2460.433,2641.594z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115482982173260284900000011396875635033446787_",
    gradientUnits: "userSpaceOnUse",
    x1: 2139.4573,
    y1: 3111.5945,
    x2: 2943.6653,
    y2: 2337.3577
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115482982173260284900000011396875635033446787_)"
    },
    d: "M2725.86,2641.594 c0,33.716-27.332,61.048-61.048,61.048h-74.319c-33.716,0-61.048-27.332-61.048-61.048l0,0 c0-33.716,27.332-61.048,61.048-61.048h74.319C2698.528,2580.545,2725.86,2607.877,2725.86,2641.594L2725.86,2641.594z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158723620131644268840000017950070548486864039_",
    gradientUnits: "userSpaceOnUse",
    x1: 2272.2395,
    y1: 3249.5166,
    x2: 3076.4478,
    y2: 2475.28
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158723620131644268840000017950070548486864039_)"
    },
    d: "M3001.904,2641.594 c0,33.716-27.332,61.048-61.048,61.048h-74.319c-33.716,0-61.048-27.332-61.048-61.048l0,0 c0-33.716,27.332-61.048,61.048-61.048h74.319C2974.572,2580.545,3001.904,2607.877,3001.904,2641.594L3001.904,2641.594z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062907275507070500300000009389135408665424026_",
    gradientUnits: "userSpaceOnUse",
    x1: 1963.5636,
    y1: 2928.8928,
    x2: 2767.772,
    y2: 2154.6558
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.63,
      fill: "url(#SVGID_00000062907275507070500300000009389135408665424026_)"
    },
    d: "M2184.389,2810.845 c0,33.716-27.332,61.048-61.048,61.048h-74.32c-33.716,0-61.048-27.332-61.048-61.048l0,0 c0-33.716,27.332-61.048,61.048-61.048h74.32C2157.057,2749.796,2184.389,2777.129,2184.389,2810.845L2184.389,2810.845z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031200325941176272440000011780161931967778485_",
    gradientUnits: "userSpaceOnUse",
    x1: 2096.3455,
    y1: 3066.8157,
    x2: 2900.5542,
    y2: 2292.5786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.63,
      fill: "url(#SVGID_00000031200325941176272440000011780161931967778485_)"
    },
    d: "M2460.433,2810.845 c0,33.716-27.332,61.048-61.048,61.048h-74.32c-33.716,0-61.048-27.332-61.048-61.048l0,0 c0-33.716,27.333-61.048,61.048-61.048h74.32C2433.101,2749.796,2460.433,2777.129,2460.433,2810.845L2460.433,2810.845z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171704007999984192900000017536454370399325856_",
    gradientUnits: "userSpaceOnUse",
    x1: 2224.0215,
    y1: 3199.4331,
    x2: 3028.23,
    y2: 2425.1958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.63,
      fill: "url(#SVGID_00000171704007999984192900000017536454370399325856_)"
    },
    d: "M2725.86,2810.845 c0,33.716-27.332,61.048-61.048,61.048h-74.319c-33.716,0-61.048-27.332-61.048-61.048l0,0 c0-33.716,27.332-61.048,61.048-61.048h74.319C2698.528,2749.796,2725.86,2777.129,2725.86,2810.845L2725.86,2810.845z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010289576298631113230000003570591130993044356_",
    gradientUnits: "userSpaceOnUse",
    x1: 2056.3962,
    y1: 3025.3188,
    x2: 2860.6047,
    y2: 2251.0818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.63,
      fill: "url(#SVGID_00000010289576298631113230000003570591130993044356_)"
    },
    d: "M2184.389,2996.644 c0,33.716-27.332,61.048-61.048,61.048h-74.32c-33.716,0-61.048-27.332-61.048-61.048l0,0 c0-33.716,27.332-61.048,61.048-61.048h74.32C2157.057,2935.595,2184.389,2962.928,2184.389,2996.644L2184.389,2996.644z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016788395748223856240000000718430194785979818_",
    gradientUnits: "userSpaceOnUse",
    x1: 2189.1785,
    y1: 3163.2415,
    x2: 2993.387,
    y2: 2389.0044
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.63,
      fill: "url(#SVGID_00000016788395748223856240000000718430194785979818_)"
    },
    d: "M2460.433,2996.644 c0,33.716-27.332,61.048-61.048,61.048h-74.32c-33.716,0-61.048-27.332-61.048-61.048l0,0 c0-33.716,27.333-61.048,61.048-61.048h74.32C2433.101,2935.595,2460.433,2962.928,2460.433,2996.644L2460.433,2996.644z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088817001908929502610000014384753686004732094_",
    gradientUnits: "userSpaceOnUse",
    x1: 2316.8533,
    y1: 3295.8596,
    x2: 3121.062,
    y2: 2521.6226
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.63,
      fill: "url(#SVGID_00000088817001908929502610000014384753686004732094_)"
    },
    d: "M2725.86,2996.644 c0,33.716-27.332,61.048-61.048,61.048h-74.319c-33.716,0-61.048-27.332-61.048-61.048l0,0 c0-33.716,27.332-61.048,61.048-61.048h74.319C2698.528,2935.595,2725.86,2962.928,2725.86,2996.644L2725.86,2996.644z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2975.361,2991.657c0,42.677-34.597,77.273-77.273,77.273h-4.709 c-42.677,0-77.273-34.597-77.273-77.273v-148.039c0-42.677,34.597-77.274,77.273-77.274h4.709 c42.677,0,77.273,34.597,77.273,77.274V2991.657z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117676583602237190790000015931508189255938444_",
    gradientUnits: "userSpaceOnUse",
    x1: 1224.483,
    y1: 3384.4248,
    x2: 1519.5557,
    y2: 3041.9302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000117676583602237190790000015931508189255938444_)"
    },
    cx: 1525.516,
    cy: 3035.012,
    r: 219.988
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003791470002512556980000015763303589062157210_",
    gradientUnits: "userSpaceOnUse",
    x1: 1686.2908,
    y1: 2792.1272,
    x2: 813.754,
    y2: 4110.2813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000003791470002512556980000015763303589062157210_)"
    },
    cx: 1525.516,
    cy: 3035.012,
    r: 212.672
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.66,
      fill: "#FFFFFF"
    },
    d: "M1350.146,2950.037c-0.51,0-1.027-0.115-1.514-0.362 c-1.662-0.837-2.33-2.865-1.491-4.526c34.194-67.743,102.546-109.827,178.374-109.827c12.103,0,24.22,1.091,36.024,3.24 c1.83,0.334,3.044,2.088,2.708,3.919c-0.333,1.833-2.063,3.042-3.919,2.711c-11.402-2.078-23.114-3.131-34.813-3.131 c-73.271,0-139.317,40.665-172.359,106.125C1352.564,2949.361,1351.376,2950.037,1350.146,2950.037z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1701.1837 1972.271)",
    style: {
      opacity: 0.59,
      fill: "#FFFFFF"
    },
    cx: 1530.15,
    cy: 3039.646,
    rx: 180.001,
    ry: 180.001
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012466572236584829990000017403934156265374850_",
    gradientUnits: "userSpaceOnUse",
    x1: 1660.2623,
    y1: 2829.896,
    x2: 1195.6537,
    y2: 3609.897
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012466572236584829990000017403934156265374850_)"
    },
    d: "M1512.485,3173.461v-19.583 c-20.414-0.817-40.607-5.635-54.949-11.914c-5.121-2.241-7.731-7.989-6.261-13.383l4.976-18.24 c1.825-6.692,9.102-10.153,15.499-7.472c14.226,5.964,31.793,10.683,50.734,10.683c19.663,0,34.327-6.667,34.327-20.331 c0-12.331-11.331-19.662-38.659-26.993c-38.993-10.666-66.989-27.663-66.989-61.99c0-30.996,22.664-54.658,61.989-60.989 v-19.585c0-6.302,5.109-11.41,11.411-11.41h11.506c6.301,0,11.411,5.108,11.411,11.41v17.584 c18.891,0.756,32.641,3.987,43.553,7.822c5.591,1.964,8.647,7.987,7.095,13.707l-4.575,16.87 c-1.764,6.506-8.717,10.069-15.021,7.685c-10.047-3.799-24.252-7.755-42.717-7.755c-23.33,0-29.994,9.663-29.994,18.33 c0,10.665,13.997,17.996,44.324,27.33c43.327,12.996,61.323,30.992,61.323,63.32c0,29.662-21.996,56.324-64.655,62.99v21.916 c0,6.302-5.109,11.411-11.41,11.411h-11.508C1517.594,3184.872,1512.485,3179.763,1512.485,3173.461z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027588028603600030720000007246128565011381132_",
    gradientUnits: "userSpaceOnUse",
    x1: 990.0924,
    y1: 3384.4248,
    x2: 1285.1649,
    y2: 3041.9302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000027588028603600030720000007246128565011381132_)"
    },
    cx: 1291.125,
    cy: 3035.012,
    r: 219.988
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093139268074691723380000004800322339166938283_",
    gradientUnits: "userSpaceOnUse",
    x1: 1451.9,
    y1: 2792.1272,
    x2: 579.3633,
    y2: 4110.2813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000093139268074691723380000004800322339166938283_)"
    },
    cx: 1291.125,
    cy: 3035.012,
    r: 212.672
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.66,
      fill: "#FFFFFF"
    },
    d: "M1115.753,2950.037c-0.51,0-1.027-0.115-1.514-0.362 c-1.662-0.837-2.33-2.865-1.491-4.526c34.194-67.743,102.546-109.827,178.377-109.827c12.1,0,24.217,1.091,36.02,3.24 c1.83,0.334,3.044,2.088,2.708,3.919c-0.332,1.833-2.057,3.042-3.919,2.711c-11.402-2.078-23.114-3.131-34.809-3.131 c-73.275,0-139.32,40.665-172.362,106.125C1118.172,2949.361,1116.984,2950.037,1115.753,2950.037z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1769.8352 1806.5316)",
    style: {
      opacity: 0.59,
      fill: "#FFFFFF"
    },
    cx: 1295.759,
    cy: 3039.646,
    rx: 180.001,
    ry: 180.001
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073682583200814957450000010070809254226480005_",
    gradientUnits: "userSpaceOnUse",
    x1: 1425.8713,
    y1: 2829.8962,
    x2: 961.2631,
    y2: 3609.8967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073682583200814957450000010070809254226480005_)"
    },
    d: "M1278.095,3173.461v-19.583 c-20.415-0.817-40.608-5.635-54.949-11.914c-5.121-2.241-7.732-7.989-6.261-13.383l4.975-18.24 c1.825-6.692,9.102-10.153,15.499-7.472c14.226,5.964,31.793,10.683,50.734,10.683c19.663,0,34.327-6.667,34.327-20.331 c0-12.331-11.331-19.662-38.659-26.993c-38.992-10.666-66.989-27.663-66.989-61.99c0-30.996,22.664-54.658,61.989-60.989 v-19.585c0-6.302,5.109-11.41,11.411-11.41h11.506c6.301,0,11.41,5.108,11.41,11.41v17.584 c18.891,0.756,32.641,3.987,43.554,7.822c5.591,1.964,8.646,7.987,7.095,13.707l-4.575,16.87 c-1.763,6.506-8.716,10.069-15.021,7.685c-10.047-3.799-24.253-7.755-42.718-7.755c-23.329,0-29.994,9.663-29.994,18.33 c0,10.665,13.997,17.996,44.325,27.33c43.327,12.996,61.323,30.992,61.323,63.32c0,29.662-21.996,56.324-64.655,62.99v21.916 c0,6.302-5.109,11.411-11.41,11.411h-11.508C1283.204,3184.872,1278.095,3179.763,1278.095,3173.461z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079474483439076103360000017292816594257813910_",
    gradientUnits: "userSpaceOnUse",
    x1: 755.7014,
    y1: 3384.4248,
    x2: 1050.774,
    y2: 3041.9302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000079474483439076103360000017292816594257813910_)"
    },
    cx: 1056.734,
    cy: 3035.012,
    r: 219.988
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088828779323486712140000000507938015079659190_",
    gradientUnits: "userSpaceOnUse",
    x1: 1217.5089,
    y1: 2792.1272,
    x2: 344.9721,
    y2: 4110.2817
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000088828779323486712140000000507938015079659190_)"
    },
    cx: 1056.734,
    cy: 3035.012,
    r: 212.672
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.66,
      fill: "#FFFFFF"
    },
    d: "M881.364,2950.037c-0.51,0-1.027-0.115-1.514-0.362 c-1.662-0.837-2.33-2.865-1.491-4.526c34.194-67.743,102.546-109.827,178.374-109.827c12.103,0,24.22,1.091,36.024,3.24 c1.83,0.334,3.044,2.088,2.708,3.919c-0.332,1.833-2.057,3.042-3.919,2.711c-11.402-2.078-23.114-3.131-34.813-3.131 c-73.271,0-139.316,40.665-172.359,106.125C883.783,2949.361,882.595,2950.037,881.364,2950.037z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1838.4868 1640.7922)",
    style: {
      opacity: 0.59,
      fill: "#FFFFFF"
    },
    cx: 1061.368,
    cy: 3039.646,
    rx: 180.001,
    ry: 180.001
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019673211789617580140000012878288540625236888_",
    gradientUnits: "userSpaceOnUse",
    x1: 1191.4805,
    y1: 2829.8962,
    x2: 726.8719,
    y2: 3609.8967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019673211789617580140000012878288540625236888_)"
    },
    d: "M1043.704,3173.461v-19.583 c-20.415-0.817-40.608-5.635-54.95-11.914c-5.121-2.241-7.732-7.989-6.26-13.383l4.975-18.24 c1.825-6.692,9.103-10.153,15.5-7.472c14.226,5.964,31.792,10.683,50.734,10.683c19.663,0,34.327-6.667,34.327-20.331 c0-12.331-11.331-19.662-38.659-26.993c-38.993-10.666-66.988-27.663-66.988-61.99c0-30.996,22.664-54.658,61.989-60.989 v-19.585c0-6.302,5.109-11.41,11.41-11.41h11.506c6.302,0,11.411,5.108,11.411,11.41v17.584 c18.891,0.756,32.642,3.987,43.554,7.822c5.591,1.964,8.647,7.987,7.095,13.707l-4.575,16.87 c-1.764,6.506-8.717,10.069-15.021,7.685c-10.047-3.799-24.252-7.755-42.717-7.755c-23.329,0-29.994,9.663-29.994,18.33 c0,10.665,13.997,17.996,44.324,27.33c43.326,12.996,61.323,30.992,61.323,63.32c0,29.662-21.996,56.324-64.654,62.99v21.916 c0,6.302-5.109,11.411-11.41,11.411h-11.508C1048.813,3184.872,1043.704,3179.763,1043.704,3173.461z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176759459318223034890000011428700677821295764_",
    gradientUnits: "userSpaceOnUse",
    x1: 359.0965,
    y1: 3424.7195,
    x2: 746.0367,
    y2: 2975.5933
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000176759459318223034890000011428700677821295764_)"
    },
    cx: 753.852,
    cy: 2966.521,
    r: 288.478
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081605981156528721260000011332671845822779286_",
    gradientUnits: "userSpaceOnUse",
    x1: 949.5496,
    y1: 2316.3032,
    x2: 740.6266,
    y2: 3010.4651
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000081605981156528721260000011332671845822779286_)"
    },
    cx: 753.852,
    cy: 2966.521,
    r: 278.886
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.66,
      fill: "#FFFFFF"
    },
    d: "M523.882,2854.042c-0.51,0-1.027-0.115-1.514-0.362 c-1.662-0.837-2.33-2.865-1.491-4.526c44.662-88.479,133.933-143.445,232.974-143.445c15.805,0,31.634,1.423,47.051,4.232 c1.83,0.334,3.044,2.088,2.708,3.919c-0.332,1.831-2.053,3.036-3.919,2.711c-15.016-2.736-30.439-4.123-45.84-4.123 c-96.484,0-183.449,53.547-226.959,139.743C526.301,2853.365,525.113,2854.042,523.882,2854.042z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1879.3661 1408.0048)",
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    cx: 759.929,
    cy: 2972.598,
    rx: 236.043,
    ry: 236.043
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169554747249901487310000006729265023072389777_",
    gradientUnits: "userSpaceOnUse",
    x1: 832.9648,
    y1: 2666.3242,
    x2: 699.8618,
    y2: 3252.6531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169554747249901487310000006729265023072389777_)"
    },
    d: "M736.765,3148.074v-25.679 c-26.77-1.072-53.25-7.391-72.057-15.624c-6.715-2.939-10.139-10.476-8.21-17.549l6.525-23.92 c2.393-8.774,11.936-13.314,20.325-9.798c18.656,7.821,41.691,14.009,66.529,14.009c25.785,0,45.014-8.743,45.014-26.66 c0-16.17-14.859-25.784-50.695-35.397c-51.132-13.986-87.845-36.276-87.845-81.291c0-40.646,29.72-71.675,81.289-79.977 v-25.683c0-8.263,6.699-14.963,14.963-14.963h15.088c8.263,0,14.963,6.699,14.963,14.963v23.059 c24.772,0.991,42.804,5.228,57.113,10.256c7.332,2.575,11.339,10.474,9.305,17.975l-6,22.122 c-2.313,8.531-11.43,13.204-19.697,10.077c-13.176-4.982-31.803-10.169-56.017-10.169c-30.593,0-39.332,12.672-39.332,24.036 c0,13.985,18.355,23.599,58.124,35.838c56.816,17.043,80.416,40.643,80.416,83.035c0,38.897-28.844,73.86-84.784,82.602v28.739 c0,8.265-6.7,14.964-14.963,14.964h-15.091C743.465,3163.038,736.765,3156.339,736.765,3148.074z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140715666877395836110000007857098740872019884_",
    gradientUnits: "userSpaceOnUse",
    x1: 18368.875,
    y1: 1779.4106,
    x2: 17998.0703,
    y2: 1991.0603,
    gradientTransform: "matrix(-1 0 0 1 19947.5723 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140715666877395836110000007857098740872019884_)"
    },
    d: "M1635.073,2124.449 c0.437-0.168,235.634-412.054,267.417-450.816c5.348-6.519,13.622-9.839,21.995-8.842l65.647,7.823l77.122,166.843 l-128.483-74.827c12.714,87.927-152.34,218.597-208.946,266.277c-5.745,4.839-6.216,13.506-1.028,18.937l22.599,23.657 c-37.102,37.607-79.914,61.755-128.234,72.924L1635.073,2124.449z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152240341401834765780000000906600461094404000_",
    gradientUnits: "userSpaceOnUse",
    x1: -8024.2163,
    y1: -4134.6108,
    x2: -8052.6812,
    y2: -3698.1438,
    gradientTransform: "matrix(0.8974 -0.4412 0.4412 0.8974 10652.2939 2161.1482)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152240341401834765780000000906600461094404000_)"
    },
    d: "M1738.323,2060.735 c0,0,14.424,4.659,19.307,17.505c2.336,6.146-0.182,13.107-5.527,16.936c-23.75,17.015-102.089,71.948-138.24,82.707 c-2.963,0.882-5.783-1.799-5.116-4.818c1.855-8.398,7.856-25.169,27.189-49.72l-1.735,3.509c-2.195,4.44,2.64,9.063,6.953,6.628 C1665.333,2119.832,1714.584,2089.957,1738.323,2060.735z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028325949565589985390000008455162308671781775_",
    gradientUnits: "userSpaceOnUse",
    x1: 18333.0039,
    y1: 1832.1942,
    x2: 19601.7109,
    y2: 1037.964,
    gradientTransform: "matrix(-1 0 0 1 19947.5723 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028325949565589985390000008455162308671781775_)"
    },
    d: "M1726.684,2225.54 c0.394-0.253,35.682-85.271,36.076-85.524c32.354-196.987,111.292-365.691,134.572-410.083 c3.917-7.466,11.348-12.392,19.75-13.11l65.872-5.624l109.291,147.782l-140.967-47.276 c30.245,83.535-104.948,244.904-150.735,303.053c-4.646,5.901-3.355,14.485,2.826,18.753l26.919,18.594 c-28.723,44.337-65.763,76.65-110.822,97.366L1726.684,2225.54z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058548385226103285070000007403687081036871863_",
    gradientUnits: "userSpaceOnUse",
    x1: -6416.7183,
    y1: -6374.3452,
    x2: -6445.1816,
    y2: -5937.9067,
    gradientTransform: "matrix(0.7895 -0.6137 0.6137 0.7895 10669.8828 3191.1018)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058548385226103285070000007403687081036871863_)"
    },
    d: "M1814.903,2142.248 c0,0,15.068,1.644,22.45,13.236c3.531,5.546,2.474,12.873-1.985,17.705c-19.815,21.469-85.416,91.12-118.642,108.972 c-2.724,1.464-6.027-0.592-5.985-3.683c0.117-8.6,2.6-26.238,16.564-54.193l-0.988,3.787c-1.251,4.793,4.419,8.341,8.15,5.084 C1755.384,2214.894,1797.569,2175.67,1814.903,2142.248z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115496680180557155210000016020118719227296147_",
    gradientUnits: "userSpaceOnUse",
    x1: 2234.4309,
    y1: 1504.3796,
    x2: 2056.9597,
    y2: 1877.2946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115496680180557155210000016020118719227296147_)"
    },
    d: "M2291.294,1680.075 c0,0,59.59,88.633,64.48,129.063c4.89,40.43-16.478,54.412-78.848,59.568c-185.604,15.343-277.1-40.283-277.1-40.283 c-12.697-80.953-21.731-101.549-127.771-145.565c0,0,134.122,10.648,161.115,0.173 C2060.162,1672.556,2291.294,1680.075,2291.294,1680.075z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141444134987803094250000014476515423902488495_",
    gradientUnits: "userSpaceOnUse",
    x1: -11127.7422,
    y1: -946.2258,
    x2: -11036.5605,
    y2: -717.4985,
    gradientTransform: "matrix(0.9446 -0.3283 0.3283 0.9446 12812.0361 -1699.1722)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141444134987803094250000014476515423902488495_)"
    },
    d: "M2053.669,1183.5 c0,0,41.504-49.106,85.628,11.143c7.991,10.912,38.686,1.91,49.938,24.75c5.81,11.793,18.359,18.492,31.287,16.108 c32.198-5.939,84.826-6.439,110.811,44.017c19.834,38.513,4.521,61.052-15.306,73.902c-14.562,9.439-19.759,28.6-10.953,43.552 c8.446,14.342,10.034,33.763-11.774,57.137c-48.871,52.379-145.614-33.24-145.614-33.24l-76.812-181.509L2053.669,1183.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090980294753772690040000000172957206810412176_",
    gradientUnits: "userSpaceOnUse",
    x1: 1856.896,
    y1: 1041.1382,
    x2: 2210.6973,
    y2: 1612.2754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090980294753772690040000000172957206810412176_)"
    },
    d: "M2130.139,1668.342 c0,0-69.393-66.076-103.551-109.841c-18.464-23.657-24.263-54.801-15.724-83.57c15.595-52.541,43.31-106.958,45.838-115.428 c3.875-12.982,81.682-12.442,81.682-12.442s153.11,99.37,213.268,267.695l-67.561,21.033c0,0-39.977-67.068-79.477-109.71 c0,0,68.349,90.291,70.755,127.254L2130.139,1668.342z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165215674197042029440000014549606328809121444_",
    gradientUnits: "userSpaceOnUse",
    x1: 2159.4482,
    y1: 1805.1047,
    x2: 2231.3352,
    y2: 1416.4657
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165215674197042029440000014549606328809121444_)"
    },
    d: "M1997.923,1694.417l52.142-56.73 l60.218,16.215c0,0,70.205,10.877,110.386,0c40.181-10.877,40.181-10.877,40.181-10.877l90.801-28.269l14.26,40.303 c3.621,10.233-0.018,21.593-8.865,27.88c-7.856,5.582-17.064,11.717-22.933,14.285c-11.958,5.231-275.455,1.654-275.455,1.654 L1997.923,1694.417z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080190330613597969280000006311547010832893064_",
    gradientUnits: "userSpaceOnUse",
    x1: 2247.6726,
    y1: 1476.0374,
    x2: 2065.7078,
    y2: 1291.826
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080190330613597969280000006311547010832893064_)"
    },
    d: "M2084.908,1253.509l52.294,97.244 c-3.453,21.227-56.917,21.826-65.176,9.15c-0.841-1.29-1.321-2.782-1.641-4.288l-31.283-64.976 c-1.343-6.336,16.027-27.685,21.744-30.728l20.786-11.064C2089.637,1244.588,2056.24,1244.253,2084.908,1253.509z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163753718286775062000000014578069204919711149_",
    gradientUnits: "userSpaceOnUse",
    x1: -9519.7314,
    y1: -4191.1265,
    x2: -9349.7178,
    y2: -4493.6938,
    gradientTransform: "matrix(0.5458 -0.8379 0.8379 0.5458 10797.9961 -4320.769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163753718286775062000000014578069204919711149_)"
    },
    d: "M1979.073,1230.688 c0,0-5.903,32.854,19.92,74.626c25.823,41.772,51.537,39.886,64.601,24.989c13.064-14.897,28.713-39.708,21.592-81.372 C2078.066,1207.268,1987.993,1188.791,1979.073,1230.688z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109733584013401181050000001604024661838852272_",
    gradientUnits: "userSpaceOnUse",
    x1: -9483.1719,
    y1: -4454.6157,
    x2: -9398.166,
    y2: -4241.3794,
    gradientTransform: "matrix(0.5458 -0.8379 0.8379 0.5458 10797.9961 -4320.769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109733584013401181050000001604024661838852272_)"
    },
    d: "M2053.926,1253.459 c0,0-41.813-54.922-73.915-7.044l0.541,16.539c0,0-41.745-1.952-37.218-40.428c4.526-38.477,38.608-64.761,85.856-51.615 c47.248,13.146,74.855,28.117,80.19,60.92c5.336,32.804-21.45,27.444-21.45,27.444s-10.231-22.635-22.586-24.18 c-12.355-1.546-7.89,16.358-7.89,16.358L2053.926,1253.459z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141436877979474275920000004958588570280537491_",
    gradientUnits: "userSpaceOnUse",
    x1: -9483.541,
    y1: -4170.7944,
    x2: -9313.5283,
    y2: -4473.3599,
    gradientTransform: "matrix(0.5458 -0.8379 0.8379 0.5458 10797.9961 -4320.769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141436877979474275920000004958588570280537491_)"
    },
    d: "M2063.521,1251.995 c0,0-21.66-28.107-1.944-33.94c19.716-5.834,18.979,27.54,17.695,39.956L2063.521,1251.995z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181086471370636169850000011425335408675532469_",
    gradientUnits: "userSpaceOnUse",
    x1: 2204.751,
    y1: 1101.6614,
    x2: 2038.8726,
    y2: 1749.7435
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181086471370636169850000011425335408675532469_)"
    },
    d: "M2170.52,1716.87 c-0.183,0.009-0.367,0.014-0.552,0.013l-239.83-0.262c-5.929-0.005-10.73-4.816-10.724-10.745 c0.006-5.931,4.835-10.83,10.748-10.723l239.83,0.261c5.929,0.005,10.73,4.817,10.723,10.745 C2180.708,1711.903,2176.192,1716.59,2170.52,1716.87z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078740685734718041040000017013508788588884354_",
    gradientUnits: "userSpaceOnUse",
    x1: 1699.6256,
    y1: 1485.7363,
    x2: 1981.2324,
    y2: 1705.621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078740685734718041040000017013508788588884354_)"
    },
    d: "M1714.542,1499.119h199.732 c14.734,0,28.145,8.503,34.43,21.83l92.336,195.793h-248.213c-9.495,0-18.026-5.802-21.516-14.632l-71.602-181.177 C1695.571,1510.464,1703.286,1499.119,1714.542,1499.119z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177454349009348731410000009922429705582236349_",
    gradientUnits: "userSpaceOnUse",
    x1: 1977.4573,
    y1: 1734.5114,
    x2: 1788.4335,
    y2: 1555.1313
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177454349009348731410000009922429705582236349_)"
    },
    d: "M1855.256,1599.508 c4.328,13.447,1.131,26.507-7.142,29.17c-8.273,2.663-18.488-6.08-22.816-19.527c-4.328-13.447-1.131-26.506,7.142-29.169 C1840.712,1577.318,1850.927,1586.061,1855.256,1599.508z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/accounting.1cd8e78fe6659c773a5df23a5d0181ce.svg";
export { ForwardRef as ReactComponent };